// @flow
import React from 'react';
import { Redirect, Location } from 'react-router-dom';
import queryString from 'query-string';

const redirectHelper = (toPath: string, routerLocation: Location, dropNext: boolean = false): Node => {
  let search = routerLocation.search
  if (dropNext) {
    const parsed = queryString.parse(search);
    delete parsed['next'];
    search = queryString.stringify(parsed);
  }

  return (
    <Redirect
      to={{
        pathname: toPath,
        search,
        state: {
          referrer: routerLocation
        },
        push: true
      }}
    />
  );
}

const redirect = (toPath: string, routerLocation: Location): Node => {
  return redirectHelper(toPath, routerLocation);
};

const next = (toPath: string, routerLocation: Location): Node => {
  return redirectHelper(toPath, routerLocation, true);
};

export default {
  redirect,
  next
}



// WEBPACK FOOTER //
// ./src/util/redirect-util.js